<template>
    <v-card flat tile color="transparent">
        <v-card-actions class="cont-btn-nextprev">
        <div class="hvr btn-slide-prev" fab small @click="prev"><v-icon color="#5A8B34" size="40">navigate_before</v-icon></div>
        <div class="hvr btn-slide-next" fab small @click="next"><v-icon color="#5A8B34" size="40">navigate_next</v-icon></div>
        </v-card-actions>
        <v-window v-model="onboarding">
            <v-window-item v-for="element in slideList" :key="element">
            <div class="btn-blue-dark btn-drag hvr" >
                <span v-html="element"></span>
            </div>
            </v-window-item>
        </v-window>
    </v-card>
</template>
<script>
    export default {
        props: {
            slideListElements: {
                type: Array,
                required: false
            },
            slideonboarding:{
                type:Number,
                default:0
            },
            slidelength:{
                type:Number,
                default:0
            }
        },
        data() {
            return {
                slideList:[],
                onboarding:0,
                length:0
            }
        },
        watch: {
            onboarding(val){
                this.$emit('valueSlide', val)
                self.onboarding = this.slideonboarding
            }
        },
        methods: {
            next () {
            this.onboarding = this.onboarding + 1 === this.length
                ? 0
                : this.onboarding + 1
            },
            prev () {
            this.onboarding = this.onboarding - 1 < 0
                ? this.length - 1
                : this.onboarding - 1
            }
        },
        mounted() {
            var self = this
            self.slideList = this.slideListElements
            self.onboarding = this.slideonboarding
            self.length = this.slidelength
        },
    }
</script>

<style lang="scss" scoped>
@import '../sass/helpers/variables';
@import '../sass/globals';
.btn-drag{
  width: 140px;
  margin: 0 auto;

}
.cont-btn-nextprev{
  position: absolute;
  width: 100%;
  margin: 0 auto;
  padding: 12px;
  top: 25%;
  .btn-slide-next{
    right: 0;
    position: absolute;
    z-index: 2;
  }
  .btn-slide-prev{
    left: 0;
    position: absolute;
    z-index: 2;
  }
}
.cont-drags{
  position: relative;

  
}
</style>
